// extracted by mini-css-extract-plugin
export var component = "PostsModuleHeader-module--component--W37gK";
export var link = "PostsModuleHeader-module--link--eXArY";
export var linkIcon = "PostsModuleHeader-module--linkIcon--wID5V";
export var title = "PostsModuleHeader-module--title--G7SM3";